import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "topbar" }
const _hoisted_4 = { class: "topbar-right" }
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "item-card"
}
const _hoisted_8 = {
  key: 1,
  class: "grid card-list"
}
const _hoisted_9 = { class: "item-title" }
const _hoisted_10 = { class: "item-meta" }
const _hoisted_11 = { class: "actions" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "item-card",
  style: {"margin-bottom":"14px"}
}
const _hoisted_17 = {
  class: "section-header",
  style: {"margin-bottom":"0"}
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "actions" }
const _hoisted_22 = {
  key: 1,
  class: "section-header",
  style: {"margin-bottom":"12px"}
}
const _hoisted_23 = { class: "actions" }
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 2,
  class: "item-card"
}
const _hoisted_26 = {
  key: 3,
  class: "grid",
  style: {"gap":"20px"}
}
const _hoisted_27 = { class: "item-title" }
const _hoisted_28 = { class: "item-meta" }
const _hoisted_29 = {
  class: "grid",
  style: {"gap":"10px"}
}
const _hoisted_30 = {
  class: "item-title",
  style: {"font-size":"15px"}
}
const _hoisted_31 = { class: "item-meta" }
const _hoisted_32 = { class: "actions" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "actions" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 2 }
const _hoisted_38 = {
  key: 0,
  class: "item-card"
}
const _hoisted_39 = {
  key: 1,
  class: "grid card-list"
}
const _hoisted_40 = { class: "item-title" }
const _hoisted_41 = { class: "item-meta" }
const _hoisted_42 = { class: "actions" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 3 }
const _hoisted_47 = {
  class: "grid",
  style: {"gap":"18px"}
}
const _hoisted_48 = { class: "item-card" }
const _hoisted_49 = {
  class: "section-header",
  style: {"margin-bottom":"10px"}
}
const _hoisted_50 = { class: "actions" }
const _hoisted_51 = {
  key: 0,
  class: "item-meta"
}
const _hoisted_52 = {
  key: 1,
  class: "grid",
  style: {"gap":"12px","margin-top":"12px"}
}
const _hoisted_53 = { class: "item-meta" }
const _hoisted_54 = { class: "actions" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "item-card"
}
const _hoisted_58 = { class: "item-title" }
const _hoisted_59 = {
  class: "form-grid",
  style: {"margin-top":"12px"}
}
const _hoisted_60 = { class: "input-field" }
const _hoisted_61 = { class: "input-field" }
const _hoisted_62 = { class: "input-field" }
const _hoisted_63 = { for: "acc-birth" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = ["min", "max"]
const _hoisted_66 = { class: "input-field" }
const _hoisted_67 = { class: "input-field" }
const _hoisted_68 = { class: "actions" }
const _hoisted_69 = {
  key: 0,
  class: "subtitle",
  style: {"color":"#a54b2a"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[17] || (_cache[17] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "title" }, "Painel do administrador"),
          _createElementVNode("p", { class: "subtitle" }, "Consulte relatorios e edite dados dos colaboradores.")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "pill" }, "Administrador", -1)),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToUser && _ctx.goToUser(...args)))
          }, "Submissoes"),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, "Sair")
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["tab", { active: _ctx.activeTab === 'submissions' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'submissions'))
        }, " Submissoes ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tab", { active: _ctx.activeTab === 'reports' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'reports'))
        }, " Consulta de documentos ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tab", { active: _ctx.activeTab === 'safety' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = 'safety'))
        }, " Seguranca do trabalho ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tab", { active: _ctx.activeTab === 'users' }]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'users'))
        }, " Usuarios ", 2)
      ]),
      (_ctx.activeTab === 'submissions')
        ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
            _cache[19] || (_cache[19] = _createElementVNode("div", {
              class: "section-header",
              style: {"margin-bottom":"12px"}
            }, [
              _createElementVNode("div", { class: "subtitle" }, "Todas as submissoes registradas.")
            ], -1)),
            (_ctx.items.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("h3", { class: "item-title" }, "Nenhuma submissao registrada", -1),
                  _createElementVNode("p", { class: "item-meta" }, "Crie um novo relatorio ou aguarde os colaboradores.", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "item-card"
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_9, _toDisplayString(item.title) + " - " + _toDisplayString(item.attraction) + " - " + _toDisplayString(_ctx.formatReportDate(item.reportDate)), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatDate(item.createdAt)) + " - " + _toDisplayString(item.author.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary",
                          type: "button",
                          onClick: ($event: any) => (_ctx.view(item.id))
                        }, "Visualizar", 8, _hoisted_12),
                        _createElementVNode("button", {
                          class: "btn btn-ghost",
                          type: "button",
                          onClick: ($event: any) => (_ctx.edit(item.id))
                        }, "Editar", 8, _hoisted_13),
                        _createElementVNode("button", {
                          class: "btn btn-accent",
                          type: "button",
                          onClick: ($event: any) => (_ctx.remove(item.id))
                        }, "Excluir", 8, _hoisted_14)
                      ])
                    ]))
                  }), 128))
                ]))
          ]))
        : (_ctx.activeTab === 'reports')
          ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
              (_ctx.selectedAuthor || _ctx.selectedType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", null, [
                        _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Filtro ativo:", -1)),
                        (_ctx.selectedAuthor)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.selectedAuthor), 1))
                          : _createCommentVNode("", true),
                        (_ctx.selectedAuthor && _ctx.selectedType)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, " - "))
                          : _createCommentVNode("", true),
                        (_ctx.selectedType)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.selectedType), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("button", {
                          class: "btn btn-ghost",
                          type: "button",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                        }, "Limpar filtro")
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "subtitle" }, "Consulta de documentos por colaborador.", -1)),
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("select", {
                        class: "tab",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedType) = $event))
                      }, [
                        _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "Todos os tipos", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentTypes, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item,
                            value: item
                          }, _toDisplayString(item), 9, _hoisted_24))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.selectedType]
                      ])
                    ])
                  ])),
              (_ctx.grouped.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[23] || (_cache[23] = [
                    _createElementVNode("h3", { class: "item-title" }, "Sem documentos para consulta", -1),
                    _createElementVNode("p", { class: "item-meta" }, "Os documentos enviados pelos colaboradores aparecerao aqui.", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grouped, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: group.author,
                        class: "item-card"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_27, _toDisplayString(group.author), 1),
                          _createElementVNode("div", _hoisted_28, _toDisplayString(group.items.length) + " submissao(oes)", 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "item-card",
                              style: {"padding":"12px"}
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_30, _toDisplayString(item.title) + " - " + _toDisplayString(item.attraction) + " - " + _toDisplayString(_ctx.formatReportDate(item.reportDate)), 1),
                                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.formatDate(item.createdAt)) + " - " + _toDisplayString(item.status), 1)
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("button", {
                                  class: "btn btn-secondary",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.view(item.id))
                                }, "Preview", 8, _hoisted_33),
                                _createElementVNode("button", {
                                  class: "btn btn-ghost",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.edit(item.id))
                                }, "Editar", 8, _hoisted_34)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            type: "button",
                            onClick: ($event: any) => (_ctx.exportDoc(group.author))
                          }, " Montar Word ", 8, _hoisted_36)
                        ])
                      ]))
                    }), 128))
                  ]))
            ]))
          : (_ctx.activeTab === 'safety')
            ? (_openBlock(), _createElementBlock("section", _hoisted_37, [
                _cache[25] || (_cache[25] = _createElementVNode("div", {
                  class: "section-header",
                  style: {"margin-bottom":"12px"}
                }, [
                  _createElementVNode("div", { class: "subtitle" }, "Submissoes de seguranca do trabalho.")
                ], -1)),
                (_ctx.safetyItems.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("h3", { class: "item-title" }, "Nenhuma submissao de seguranca", -1),
                      _createElementVNode("p", { class: "item-meta" }, "Aguarde novos documentos ou atualize.", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.safetyItems, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "item-card"
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h3", _hoisted_40, _toDisplayString(item.title) + " - " + _toDisplayString(item.attraction) + " - " + _toDisplayString(_ctx.formatReportDate(item.reportDate)), 1),
                            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.formatDate(item.createdAt)) + " - " + _toDisplayString(item.author.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("button", {
                              class: "btn btn-secondary",
                              type: "button",
                              onClick: ($event: any) => (_ctx.view(item.id))
                            }, "Visualizar", 8, _hoisted_43),
                            _createElementVNode("button", {
                              class: "btn btn-ghost",
                              type: "button",
                              onClick: ($event: any) => (_ctx.edit(item.id))
                            }, "Editar", 8, _hoisted_44),
                            _createElementVNode("button", {
                              class: "btn btn-accent",
                              type: "button",
                              onClick: ($event: any) => (_ctx.remove(item.id))
                            }, "Excluir", 8, _hoisted_45)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _cache[26] || (_cache[26] = _createElementVNode("h3", { class: "item-title" }, "Usuarios cadastrados", -1)),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("button", {
                          class: "icon-btn",
                          type: "button",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openAccountForm && _ctx.openAccountForm(...args)))
                        }, "+")
                      ])
                    ]),
                    (_ctx.accounts.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, "Nenhum usuario encontrado."))
                      : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: acc.username,
                              class: "list-row"
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("strong", null, _toDisplayString(acc.name), 1),
                                _createElementVNode("div", _hoisted_53, _toDisplayString(acc.username) + " - " + _toDisplayString(acc.role), 1)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("button", {
                                  class: "btn btn-secondary",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.editAccount(acc))
                                }, "Editar", 8, _hoisted_55),
                                _createElementVNode("button", {
                                  class: "btn btn-ghost",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.viewUserSubmissions(acc.name))
                                }, " Ver submissoes ", 8, _hoisted_56)
                              ])
                            ]))
                          }), 128))
                        ]))
                  ]),
                  (_ctx.showAccountForm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("h3", _hoisted_58, _toDisplayString(_ctx.accountForm.isEditing ? 'Editar conta' : 'Nova conta'), 1),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _cache[27] || (_cache[27] = _createElementVNode("label", { for: "acc-name" }, "Nome", -1)),
                            _withDirectives(_createElementVNode("input", {
                              id: "acc-name",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.accountForm.name) = $event)),
                              type: "text",
                              placeholder: "Nome completo"
                            }, null, 512), [
                              [_vModelText, _ctx.accountForm.name]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _cache[28] || (_cache[28] = _createElementVNode("label", { for: "acc-username" }, "Username", -1)),
                            _withDirectives(_createElementVNode("input", {
                              id: "acc-username",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.accountForm.username) = $event)),
                              type: "text",
                              placeholder: "usuario"
                            }, null, 512), [
                              [_vModelText, _ctx.accountForm.username]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("label", _hoisted_63, [
                              _cache[29] || (_cache[29] = _createTextVNode("Data de nascimento ", -1)),
                              (_ctx.accountForm.isEditing)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_64, "(em branco mantém)"))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              id: "acc-birth",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.accountForm.birthDate) = $event)),
                              type: "date",
                              min: _ctx.MIN_BIRTH_DATE,
                              max: _ctx.maxBirthDate()
                            }, null, 8, _hoisted_65), [
                              [_vModelText, _ctx.accountForm.birthDate]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _cache[30] || (_cache[30] = _createElementVNode("label", { for: "acc-password" }, "Password", -1)),
                            _withDirectives(_createElementVNode("input", {
                              id: "acc-password",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.accountForm.password) = $event)),
                              type: "text",
                              placeholder: "senha"
                            }, null, 512), [
                              [_vModelText, _ctx.accountForm.password]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _cache[32] || (_cache[32] = _createElementVNode("label", { for: "acc-role" }, "Role", -1)),
                            _withDirectives(_createElementVNode("select", {
                              id: "acc-role",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.accountForm.role) = $event))
                            }, [...(_cache[31] || (_cache[31] = [
                              _createElementVNode("option", { value: "user" }, "Usuario", -1),
                              _createElementVNode("option", { value: "admin-obra" }, "Administrador", -1)
                            ]))], 512), [
                              [_vModelSelect, _ctx.accountForm.role]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              type: "button",
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.saveAccount && _ctx.saveAccount(...args)))
                            }, _toDisplayString(_ctx.accountForm.isEditing ? 'Atualizar' : 'Criar'), 1),
                            _createElementVNode("button", {
                              class: "btn btn-ghost",
                              type: "button",
                              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeAccountForm && _ctx.closeAccountForm(...args)))
                            }, "Fechar")
                          ]),
                          (_ctx.accountError)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(_ctx.accountError), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
    ])
  ]))
}